import { find, findAll } from "../utils/dom";
import Swiper from "swiper";


const PageAdministrativo = () =>{
	const page = find(`[js-page='administrativo']`);
	if(!page) return;

	const SwiperOptionsContato = new Swiper(".swiper-options-contato", {
		slidesPerView: 'auto',
		spaceBetween: 8,
		breakpoints:{
			767:{
				spaceBetween: 16,
			}
		}
	})

	const SwiperFormContato = new Swiper(".swiper-formulario-contato", {
		slidesPerView: 1,
		mousewheel: false,
		simulateTouch: false,
	});

	const $ ={
		btsFormButton: findAll("[js-button-form]"),
	}

	

	function resetBtsFormTo(){
		if(!$.btsFormButton) return;

		$.btsFormButton.forEach((bt)=>{
			bt.classList.remove("active");
		})
	}

	function btsFormTo(){
		if(!$.btsFormButton) return;

		$.btsFormButton.forEach((bt)=>{
			bt.addEventListener("click", (e)=>{

				const id = e.target.getAttribute('js-button-form');
				SwiperFormContato.slideTo(id);

				resetBtsFormTo();
				e.target.classList.add("active");
			})
		})
	}

	btsFormTo();

	
	const url = new URL(window.location.href);
	const pageContato = url.searchParams.get('contato');

	console.log(pageContato)

	const index = parseInt(pageContato, 10);
if (!isNaN(index) && index >= 0) {
	SwiperFormContato.slideTo(index - 1);
	resetBtsFormTo();
	$.btsFormButton[index - 1].classList.add('active');
}

	// if(pageContato && pageContato > 0){
	// 	SwiperFormContato.slideTo(pageContato);
	// 	resetBtsFormTo();
	// 	$.btsFormButton[pageContato - 1].classList.add('active');
	// }

}

export default PageAdministrativo;